import { Store } from '@website/Store';
import { useContext } from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Admin Only Feature
 *
 * Only displays if the user is an admin, and wraps the content in a bootstrap
 * alert with "Admin" in the top right corner.
 */
export function AdminFeature({
  children,
  inline = false,
}: {
  children: React.ReactNode;
  inline?: boolean;
}) {
  // Hide if the user is not an admin
  const { state } = useContext(Store);
  const isAdmin = state.user?.roles.includes('admin');
  if (!isAdmin) {
    return null;
  }

  return (
    <Alert
      variant="danger"
      style={{ position: 'relative' }}
      className={`${inline ? 'd-inline-block' : ''} border border-danger my-3`}
    >
      <div
        style={{
          position: 'absolute',
          top: -11,
          right: 5,
          background: 'transparent',
          padding: '0 10px',
          textShadow: '-2px 0 white, 0 2px white, 2px 0 white, 0 -2px white',
        }}
        className="small text-danger"
      >
        <strong>Admin</strong>
      </div>
      {children}
    </Alert>
  );
}
